import { render, staticRenderFns } from "./popupCarelloModale.vue?vue&type=template&id=5429e726&"
import script from "./popupCarelloModale.vue.ts?vue&type=script&lang=ts&"
export * from "./popupCarelloModale.vue.ts?vue&type=script&lang=ts&"
import style0 from "./popupCarelloModale.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports